import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class FlightsFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.flights],
      name: "flights",
      value,
    });
  }
}

export default FlightsFilter;
export { FlightsFilter };
